import { useRef } from "react";

import BannerImage1 from '../../../assets/bannerImage1.png'
import BannerImage2 from '../../../assets/bannerImage2.jpeg'
import TestImage1 from '../../../assets/SampleBanner.webp'
import TestImage2 from '../../../assets/SampleBanner2.png'
import TestImage from '../../../assets/sample-image.png'
import classes from './Home.module.scss';
import { Banner } from "../../../components/Banner/Banner";
import { NewsletterForm } from "../../../components/Newsletter/NewsletterForm";

const Banner2Data = [
    {
        designer: "Coming Soon",
        title: "Designers From Across The Gulf",
        offer: "ONE MARKETPLACE, MANY ATELIERS",
        image: BannerImage1
    },
    {
        designer: "Coming Soon",
        title: "Customised To Your Measurements",
        offer: "ON EVERY SINGLE ORDER",
        image: BannerImage2
    }
]

const HeroData = [
    {
        productImage: TestImage1,
        text: "Summer collection 1",
        productId: 1234
    },
    {
        productImage: TestImage2,
        text: "Summer collection 2",
        productId: 1234
    },
    {
        productImage: TestImage,
        text: "Summer collection 3",
        productId: 1234
    }

]

export const Home = () => {
    const newsletterRef = useRef(null);

    const scrollToNewsletter = () => {
        newsletterRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    return (
        <>
            <Banner bannerData={HeroData} onSlideClick={scrollToNewsletter} />
            <div className={classes.div}>
                <div className={classes.div2}>

                    {Banner2Data.map((data) => {
                        return (
                            <div key={data.title} className={classes.column2}>
                                <div className={classes.div9}>
                                    <img
                                        loading="lazy"
                                        src={data.image}
                                        className={classes.img}
                                        alt="text"
                                    />
                                    <div className={classes.div10}>
                                        <div className={classes.div11}>{data.designer}</div>
                                        <div className={classes.div12}>
                                            {data.title}
                                        </div>
                                        <div className={classes.div13}>{data.offer}</div>
                                        {/* One element, not two nested ones: the wrapper used to
                                            carry .div14 as well, so its margin-top applied twice
                                            and pushed "Notify Me" out of the fixed-height card. */}
                                        <div onClick={scrollToNewsletter} className={classes.div14}>
                                            Notify Me
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div ref={newsletterRef} className={classes.heroHeader}>Join Our Newsletter</div>
                <div className={classes.NewsletterSection}>
                    <div className={classes.NewsletterCopy}>
                        We are bringing our first designers and sellers onto the platform now.
                        Leave your email and we will let you know the moment the marketplace
                        opens — subscribers get first access and an exclusive launch offer.
                    </div>
                    <NewsletterForm />
                </div>

                <div className={classes.heroHeader}>Abayas & Clothing for Women Online in UAE</div>

                <h2 className={classes.InfoHeader}>One Marketplace, Every Abaya You Have Been Looking For</h2>
                <div className={classes.Info}>Finding the right abaya usually means trailing through souks and boutiques, hoping the one shop you like has your size, your fabric and your budget. Abayatique brings the search into one place. We bring together trusted sellers and independent designers from across the UAE and the wider Gulf, so a single browse puts dozens of ateliers, hundreds of designs and every price point in front of you at once — each one vetted by us before it ever reaches your screen.</div>

                <h2 className={classes.InfoHeader}>Every Style, Every Occasion, Every Fabric</h2>
                <div className={classes.Info}>Because we host many sellers rather than one house style, the range is genuinely wide. Classic closed-front and open abayas. Softly flared and butterfly cuts. Kimono and cardigan styles for layering. Everyday crepe and nida that survive the school run and the commute. Embroidered, beaded and hand-finished pieces for weddings, Eid and evening events. Breathable summer weights for peak heat, and richer fabrics for cooler months. Add matching shaylas, hijabs, inner slips and coordinated sets, and you can build a complete look without leaving the site.</div>

                <h2 className={classes.InfoHeader}>Made Your Way: Customisation on Every Single Order</h2>
                <div className={classes.Info}>This is where Abayatique is different. Every order on our marketplace can be customised — not a select few pieces, every one of them. Give us your exact length and sleeve measurements instead of settling for a generic S, M or L. Change the fabric or the colour. Adjust the neckline, the cuffs or the closure. Add or remove embroidery, request your initials, or ask for a modest lining. Your requirements go straight to the seller who makes the piece, and they confirm the details with you before a single stitch is cut. You get something fitted to you at a fraction of what fully bespoke tailoring normally costs.</div>

                <h2 className={classes.InfoHeader}>Why Shop Abayas at Abayatique</h2>
                <div className={classes.Info}>You buy from many sellers but deal with one checkout, one delivery and one support team. Every seller is verified before joining, every listing carries clear fabric details and full measurements, and our size guidance is written to take the guesswork out of ordering online. Orders are delivered across the UAE with tracking from the moment they leave the seller, and if something is not right, our returns team handles it for you rather than sending you back to the seller. Whether you are replacing an everyday abaya or commissioning something for an occasion that matters, you get boutique-level attention with the convenience of shopping from home.</div>
            </div>
        </>
    );
}
